export default {
  watch: {
    page_title: function (val) {
      /**
       * Следит за изменением заголовка страницы
       * @param {string} val - новое значение заголовка
       */
      this.setMainTitle()
    }
  },
  computed: {

  },
  methods: {
    setPageTitleWithObject (type, { uid, id }, separator = ' ', short = null, finalizer = () => {}) {
      /**
       * Устанавливает заголовок страницы на основе объекта
       * @param {string} type - тип данных для загрузки
       * @param {Object} identifier - объект с идентификатором
       * @param {string} separator - разделитель между частями заголовка
       * @param {string|null} short - короткое название
       * @param {Function} finalizer - функция обратного вызова после загрузки
       */
      this.$store.dispatch(
        'stringvalue/loadStringValue',
        {
          type,
          uid,
          id,
          short,
          finalizer: (value) => {
            this.page_title += `${separator}${value}`
            finalizer(value)
          }
        })
    },
    setMainTitle () {
      /**
       * Устанавливает главный заголовок страницы в хранилище
       */
      this.$store.commit('mainpage/changeTitle', this.page_title)
    }
  },
  created () {
    /**
     * Устанавливает заголовок при создании компонента
     */
    this.setMainTitle()
  }

}
